export default __webpack_public_path__ + "static/portfolio-20-8144539e3893a44bdc6e68dd0349a661.jpg";